import { Controller } from "@hotwired/stimulus"
import { sendAnalyticsEvent } from "../../lib/analytics_beacon"

// A search result card reports that it was actually seen — at least half in
// the viewport for a moment, once per page (workplace--impression's rule) —
// and that it was clicked, with the rank it held on the page. Together they
// tell "shown and ignored" from "never scrolled to".
export default class extends Controller {
  static values = {
    subjectType: String,
    subjectId: String,
    position: Number,
    query: String,
    searchId: String,
    dwell: { type: Number, default: 1000 }
  }

  connect() {
    if (!this.subjectTypeValue || !this.subjectIdValue) return

    this.onClick = event => this.reportClick(event)
    this.element.addEventListener("click", this.onClick)

    if (!("IntersectionObserver" in window)) return
    this.observer = new IntersectionObserver(entries => this.track(entries), { threshold: 0.5 })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.cancelDwell()
    this.observer?.disconnect()
    this.element.removeEventListener("click", this.onClick)
  }

  track(entries) {
    const visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.5)
    visible ? this.startDwell() : this.cancelDwell()
  }

  startDwell() {
    if (this.timer || this.seen) return

    this.timer = setTimeout(() => this.reportView(), this.dwellValue)
  }

  cancelDwell() {
    clearTimeout(this.timer)
    this.timer = null
  }

  reportView() {
    this.timer = null
    if (this.seen || document.visibilityState === "hidden") return

    this.seen = true
    this.observer?.disconnect()
    this.send("search_result_viewed", { appeared_in_search: true })
  }

  // Any link inside the card counts as choosing it; the share button copies a
  // link rather than opening the item and reports itself separately.
  reportClick(event) {
    if (!event.target.closest("a")) return

    this.send("search_result_clicked", {})
  }

  send(name, extra) {
    sendAnalyticsEvent(name, {
      subjectType: this.subjectTypeValue,
      subjectId: this.subjectIdValue,
      properties: {
        query: this.queryValue,
        search_id: this.searchIdValue,
        search_position: this.positionValue,
        content_type: this.subjectTypeValue,
        ...extra
      }
    })
  }
}
